<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="apply"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Free Trial Application</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onNextClick(f)" #f="ngForm" novalidate>

            <!-- Dealership Information -->
            <!-- <ion-list-header color="secondary">
                Dealership Information
            </ion-list-header>

            <ion-item>
                <ion-label position="stacked">Dealership Name</ion-label>
                <ion-input data-test="dealershipName" color="secondary" type="text" name="dealershipName" #dealershipName="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && dealershipName.invalid }" [(ngModel)]="vm.dealershipName"
                    id="dealershipName" placeholder="Required.">
                </ion-input>
                @if (submitted && dealershipName.invalid) {
                <div>
                    <div class="errorMsg">Dealership name is required.</div>
                </div>
                }
            </ion-item> -->

            <!-- <ion-item button (click)="onStateClick()" data-test="state">
                <ion-label>
                    <p>State</p>
                    <h2>{{ vm.stateName || 'Select State (Required)' }}</h2>
                </ion-label>
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>
            @if (submitted && !vm.stateName) {
            <ion-item lines="none">
                <div class="errorMsg">State is required.</div>
            </ion-item>
            } -->

            <!-- Manager Information -->
            <ion-list-header color="secondary">
                Manager Information (Page 1 of 2)
            </ion-list-header>

            <ion-item>
                <ion-label position="stacked">First Name</ion-label>
                <ion-input data-test="firstName" color="secondary" type="text" name="firstName" #firstName="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" [(ngModel)]="vm.user.firstName"
                    id="firstName" placeholder="Required.">
                </ion-input>
                @if (submitted && firstName.invalid) {
                <div>
                    <div class="errorMsg">First name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Last Name</ion-label>
                <ion-input data-test="lastName" color="secondary" type="text" name="lastName" #lastName="ngModel"
                    required [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" [(ngModel)]="vm.user.lastName"
                    id="lastName" placeholder="Required.">
                </ion-input>
                @if (submitted && lastName.invalid) {
                <div>
                    <div class="errorMsg">Last name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Cell Phone</ion-label>
                <ion-input color="secondary" type="tel" appPhoneMask placeholder="(xxx) xxx-xxxx" #cellPhone="ngModel"
                    minlength="14" maxlength="14" name="cellPhone"
                    [ngClass]="{'is-invalid': f.submitted && cellPhone.invalid}" required [(ngModel)]="vm.user.cellPhone"
                    id="cellPhone" data-test="cellPhone">
                </ion-input>
                @if (submitted && cellPhone.invalid) {
                <div data-test="cellPhoneErr">
                    <div class="validationErrorMsg">Cell phone is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label position="stacked">Email</ion-label>
                <ion-input data-test="email" color="secondary" type="email" name="email" #email="ngModel" required
                    [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" [(ngModel)]="vm.user.email" id="email"
                    placeholder="Required.">
                </ion-input>
                @if (submitted && email.invalid) {
                <div>
                    <div class="errorMsg">Email address is required.</div>
                </div>
                }
            </ion-item>
            <br />

<!-- 
            <ion-list-header color="secondary">
                Qualification Requirements
            </ion-list-header>

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.questionsAndAnswers.hasReliableInternet" name="hasReliableInternet" data-test="hasReliableInternet"></ion-checkbox>
                <ion-label class="ion-text-wrap">My dealership has a reliable internet connection.</ion-label>
            </ion-item>

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.locatedInUnitedStates" name="locatedInUnitedStates"
                    data-test="locatedInUnitedStates"></ion-checkbox>
                <ion-label class="ion-text-wrap">My dealership is located in the United States.</ion-label>
            </ion-item>

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.isServiceManager" name="isServiceManager" data-test="isServiceManager"></ion-checkbox>
                <ion-label class="ion-text-wrap">I am the service manager of the service department.</ion-label>
            </ion-item>

            <ion-list-header color="secondary">
                Trial Terms Acknowledgment
            </ion-list-header>

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.acceptsTrialTerms" name="acceptsTrialTerms" data-test="acceptsTrialTerms"></ion-checkbox>
                <ion-label class="ion-text-wrap">I understand the trial period is 15 days and can be extended by completing onboarding tasks.</ion-label>
            </ion-item>

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.commitsToOnboarding" name="commitsToOnboarding" data-test="commitsToOnboarding"></ion-checkbox>
                <ion-label class="ion-text-wrap">I commit to completing the onboarding process to fully evaluate ShuttleNomix.</ion-label>
            </ion-item>
        -->
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled (click)="onNextClick(f)" title="Next" data-test="next1">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>


<!--
            <ion-item button (click)="onJobTitleClick()" data-test="jobTitle">
                <ion-label>
                    <p>Job Title</p>
                    <h2>{{ vm.jobTitle || 'Select Role (Required)' }}</h2>
                </ion-label>
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>
            @if (submitted && !vm.jobTitle) {
            <ion-item lines="none">
                <div class="errorMsg">Job title is required.</div>
            </ion-item>
            }

            <ion-item button (click)="onDealershipSizeClick()" data-test="dealershipSize">
                <ion-label>
                    <p>Dealership Size</p>
                    <h2>{{ vm.dealershipSize || 'Select Size (Required)' }}</h2>
                </ion-label>
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>
            @if (submitted && !vm.dealershipSize) {
            <ion-item lines="none">
                <div class="errorMsg">Dealership size is required.</div>
            </ion-item>
            }

            <ion-item button (click)="onReferralSourceClick()" data-test="referralSource">
                <ion-label>
                    <p>How did you hear about ShuttleNomix?</p>
                    <h2>{{ vm.referralSource || 'Select Source (Optional)' }}</h2>
                </ion-label>
                <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>

                        <ion-item button (click)="onMonthlyTripsClick()" data-test="monthlyTrips">
                            <ion-label>
                                <p>Estimated Monthly Shuttle Trips</p>
                                <h2>{{ vm.monthlyTrips || 'Select Range (Required)' }}</h2>
                            </ion-label>
                            <ion-icon name="chevron-forward" slot="end"></ion-icon>
                        </ion-item>
                        @if (submitted && !vm.monthlyTrips) {
                        <ion-item lines="none">
                            <div class="errorMsg">Estimated monthly trips is required.</div>
                        </ion-item>
                        }

            <ion-item>
                <ion-checkbox slot="start" [(ngModel)]="vm.shuttleSource" name="shuttleSource"
                    data-test="shuttleSource"></ion-checkbox>
                <ion-label class="ion-text-wrap">My dealership has an in-house shuttle department, outsources shuttle services.</ion-label>
            </ion-item>



-->